// size.font accepts only an alias or a raw "Npx" string; a bare number throws
// opaquely at render (#61/#62). number→"Npx" keeps a legit custom px, no remap.

const PX_RE = /^-?\d+px$/;
const NUMERIC_RE = /^-?\d+$/;

function label(context) {
  if (!context) {
    return "";
  }
  const { element, option } = context;
  return ` (element "${element ?? "?"}", option "${option ?? "?"}")`;
}

function normalizeFontSizeStyleValue(value, context) {
  if (value === undefined || value === null || value === "") {
    return "standard";
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? `${value}px` : "standard";
  }
  if (typeof value === "string") {
    if (PX_RE.test(value)) {
      return value;
    }
    if (NUMERIC_RE.test(value)) {
      return `${value}px`;
    }
    return value;
  }
  // eslint-disable-next-line no-console
  console.error(
    `normalizeFontSizeStyleValue: font-size ${JSON.stringify(value)} `
    + `(typeof ${typeof value}) is not a valid size.font value${label(context)} `
    + "— falling back to \"standard\". Fix the source data.",
  );
  return "standard";
}

module.exports = normalizeFontSizeStyleValue;
module.exports.normalizeFontSizeStyleValue = normalizeFontSizeStyleValue;
